var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exchange-list-wrap margin-top-20"},[_c('ve-line',{attrs:{"data":_vm.chartData,"extend":_vm.extend,"settings":_vm.chartSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }